export const menuItems = [
  {
    label: 'Διαχείριση Χρηστών',
    icon: 'pi pi-user',
    routerLink: '/user/search',
    roles: ['Admin'],
  },
  {
    label: 'Διαχείριση Αιτήσεων Πρόσβασης API',
    icon: 'pi pi-inbox',
    routerLink: '/api-requests/search',
    roles: ['Admin', 'ApiRequester'],
  },
  {
    label: 'Τεκμηρίωση Μεθόδων API',
    icon: 'pi pi-list-check',
    routerLink: '/api-endpoints-documentation/search',
    roles: ['Admin', 'ApiRequester'],
  }
];
